module.exports = __webpack_public_path__ + "img/Z81_13.3ae791ad.jpg";